package one.healthium.log_food.ui.camera

import androidx.compose.runtime.Immutable

@Immutable
data class CameraUiState(
    val isLoading: Boolean = false,
    val frozenPhotoBytes: StableByteArray? = null,
    val frozenPhotoPath: String? = null,
)
